<template>
	<div class="app" style="width: 100%;">
		<el-container direction="vertical">
			<el-header style="padding:0;height: auto;">
				<IndexHead style="width:100%;"></IndexHead>
			</el-header>
			<el-main style="padding:0;">
				<el-row type="flex" justify="center">
					<el-col :span="22">
				<div class="text color flex align-center space-between"
					style="background: #f5f5f5;margin: 25px auto;border-radius: 10px;">
					<div class="flex align-center" style="margin:5px 50px">
						<img :src="headImg" class="xiaoshou" style="width:80px;height:80px;border-radius: 50%;"
							@click="clickinfo()" />
						<div class="flex direction-column space-around"
							style="font-size: 12px;color:#999999;margin:12px 15px;height:90px;text-align: left;">
							<div style="font-weight: 700;color:#000000">{{userInfo.name ? userInfo.name : userInfo.mobile}}</div>
							<!-- <div>{{userInfo.sex}}<span style="margin:0 6px;">|</span>{{userInfo.address}}</div> -->
							<!-- <div>{{userInfo.major}}<span style="margin:0 6px;">|</span>{{userInfo.school}}</div> -->
							<div>{{userInfo.vip_flag == 1 ? 'VIP会员' : '普通会员'}}<span style="margin:0 6px;" v-if="userInfo.vip_end_date">|</span>{{userInfo.vip_end_date ? userInfo.vip_end_date : ''}}</div>
						</div>
					</div>
					<div class="flex">
						<div class="flex direction-column align-center space-between font"
							style="height:42px; color:#999999;border-left: 1px solid #dddddd;padding:0 20px;">
							<span class="color">{{collection}}</span>
							<span>我的收藏</span>
						</div>
						<div class="flex direction-column align-center space-between font"
							style="color:#999999;border-left: 1px solid #dddddd;padding:0 20px;">
							<span class="color">{{follow}}</span>
							<span>我的关注</span>
						</div>
					</div>
				</div>
				</el-col>
				</el-row>
				<el-row type="flex" justify="center">
					<el-col :span="22">
				<div class="content flex" style="margin: 0 auto;">
					<div class="font foll">
						<div class="xiaoshou" :class="type==1?'color':''" @click="mycollection()">我的收藏</div>
						<div class="xiaoshou" :class="type==2?'color':''" @click="myfollow()">我的关注</div>
					</div>
					<div v-if="type==0" class="flex-all" style="margin-left: 20px;">
						<div
							style="border-bottom: 1px solid #dddddd;padding-bottom:10px;margin-bottom: 15px;text-align:left ;">
							账号信息
						</div>
						<div style="width: 100%;" class="flex direction-column align-center info font justify-center">
							<div>
								<div>手机号码：</div>
								<input type="text" v-model="userInfo.mobile" />
							</div>
							<div>
								<div>邮箱：</div>
								<input type="text" v-model="userInfo.email" />
							</div>
							<div>
								<div>密码：</div>
								<input type="text" v-model="userInfo.psw" />
							</div>
							<div>
								<div>姓名：</div>
								<input type="text" v-model="userInfo.name" />
							</div>
							<div>
								<div>公司名称：</div>
								<input type="text" v-model="userInfo.company_name" />
							</div>
							<div>
								<div>职位：</div>
								<input type="text" v-model="userInfo.position_name" />
							</div>
						</div>
						<div style="text-align: center;">
							<div class="borders backbg font xiaoshou"
								style="width:65px;padding:8px;color:#FFFFFF;margin:30px auto;" @click="save">保存</div>
						</div>
					</div>
					<div v-if="type==1" style="margin-left: 20px;width:100%">
						<Collection></Collection>
					</div>
					<div v-if="type==2" style="margin-left: 20px;width:100%">
						<Follow></Follow>
					</div>
				</div>
				</el-col>
				</el-row>
			</el-main>
			<el-footer style="padding:0;height: 30px;margin-top: 60px;width:100%;">
				<div class="font"
					style="width:100%;background: #282828;height: 50px;color:#ffffff;line-height: 50px;text-align: center;">
					版权所有：HR校招助手网 <span style="width: 100px;display: inline-block;"></span> CNZZ
				</div>
			</el-footer>
		</el-container>
		<div style="height: 50px;width: 100%;"></div>
	</div>
</template>

<script>
	import IndexHead from '../components/IndexHead.vue';
	import Collection from '../components/Collection.vue';
	import Follow from '../components/Follow.vue';
	export default {
		name: 'index',
		components: {
			IndexHead,
			Collection,
			Follow
		},
		data() {
			return {
				type: 0, //显示的状态   0：用户信息   1：我的收藏   2：我的关注
				headImg: require('../assets/img/123.png'),
				userInfo: {
					name: '',
					sex: '',
					address: '',
					major: '',
					school: '',
					vip_flag: 0,
					viptime: '',
					mobile: '',
					email: '',
					psw: '',
					company_name: '',
					position_name: ''
				},
				collection: 0,
				follow: 0,
			}
		},
		mounted() {
			this.userInfos();
			this.$axios.get(`/api/user/collect/count?api_token=${window.localStorage.getItem('token')}`).then(res => {
				this.collection = res.data.data.collect_count
			})
			this.$axios.get(`/api/user/follow/count?api_token=${window.localStorage.getItem('token')}`).then(res => {
				this.follow = res.data.data.follow_count
			})
		},
		methods: {
			save(){
				this.$axios.post('/api/user/update',{
					mobile: this.userInfo.mobile,
					password: this.userInfo.password,
					email: this.userInfo.email,
					company_name: this.userInfo.company_name,
					name: this.userInfo.name,
					position_name: this.userInfo.position_name,
					api_token: window.localStorage.getItem('token')
				}).then(res => {
					if(res.data.code == 200){
						this.$message.success('保存成功')
						if(this.userInfo.name) {
							this.$store.commit('USERNAME',this.userInfo.name)
						}else{
							this.$store.commit('USERNAME',this.userInfo.mobile)
						}
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			clickinfo() {
				this.type = 0;
			},
			mycollection() {
				this.type = 1;
			},
			myfollow() {
				this.type = 2;
			},
			// 获取用户信息
			userInfos() {
				this.$axios
					.get(`/api/user/getUserByToken?api_token=${window.localStorage.getItem('token')}`)
					.then((res) => {
						// console.log(res,"res");
						this.userInfo = res.data.data;
					});
			}
		}
	}
</script>
<style scoped lang="less">
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		// text-align: center;
		color: #2c3e50;
	}

	#navs {
		display: flex;
		justify-content: space-around;
	}

	#nav {
		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}

	.foll>div {
		background-color: #f5f5f5;
		width: 103px;
		text-align: left;
		padding: 20px;
	}

	.foll>div:first-child {
		border-bottom: 1px solid #dddddd;
	}

	input {
		width: 250px;
		outline: none;
		border: 1px solid #eeeeee;
		padding: 7px 10px;
		margin-left: 5px;
	}

	.info>div {
		margin: 7px;
		display: flex;
		align-items: center;
	}

	.info>div>div {
		width: 80px;
		text-align: right;
	}
</style>
